/**
 * Converts a string to title case, where the first letter of each word is capitalized
 * and the remaining letters are lowercase.
 *
 * @param str - The input string to convert
 * @returns The string in title case format
 *
 * @example
 * toTitleCase("crime and punishment") // "Crime And Punishment"
 * toTitleCase("THE REPUBLIC") // "The Republic"
 */
export function toTitleCase(str: string): string {
  return str.replace(/\w\S*/g, (word) => {
    const firstChar = word.charAt(0).toUpperCase();
    const remainingChars = word.slice(1).toLowerCase();
    return firstChar + remainingChars;
  });
}

/**
 * Converts a snake_case string to title case with spaces.
 * Underscores are replaced with spaces and each word is capitalized.
 *
 * @param str - The input string in snake_case format
 * @returns The string in title case format with spaces
 *
 * @example
 * snakeCaseToTitle("team_leader") // "Team Leader"
 * snakeCaseToTitle("user_profile_settings") // "User Profile Settings"
 * snakeCaseToTitle("admin") // "Admin"
 */
export function snakeCaseToTitle(str: string): string {
  return toTitleCase(str.replace(/_/g, " "));
}
